import type { Events, ItemTypes } from './events'

export type Topic = keyof Events
export type EventPayload = Events[keyof Events]
export type EventSubscriber = (payload: EventPayload) => void
export type { Events, ItemTypes }

const topics = new Map<Topic, EventSubscriber[]>()

export const subscribe = <T extends Topic>(
  topic: T,
  subscribers: ((payload: Events[T]) => void)[],
): void => {
  if (!topics.has(topic)) {
    topics.set(topic, [])
  }
  const existingSubscribers = topics.get(topic)!
  subscribers.forEach((subscriber) => existingSubscribers.push(subscriber as EventSubscriber))
}

export const unsubscribe = (topic: Topic, subscriber: EventSubscriber): void => {
  const subscribers = topics.get(topic) || []
  topics.set(
    topic,
    subscribers.filter((sub) => sub !== subscriber),
  )
}

export const publish = <K extends Topic>(topic: K, payload: Events[K]): void => {
  const subscribers = topics.get(topic) || []
  subscribers.forEach((subscriber) => subscriber(payload))
}
